import { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MILESTONES = [10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];

const highestMilestone = (total) => {
  let m = 0;
  for (const step of MILESTONES) {
    if (total >= step) m = step;
    else break;
  }
  return m;
};

export const MilestoneBadge = () => {
  const [milestone, setMilestone] = useState(0);

  useEffect(() => {
    axios.get(`${API}/recent-sales?limit=1`)
      .then(res => setMilestone(highestMilestone(res.data?.total_sales || 0)))
      .catch(() => {});
  }, []);

  if (milestone === 0) return null;

  return (
    <div className="flex justify-center mb-8" data-testid="milestone-badge">
      <div className="inline-flex items-center gap-2 rounded-full border border-green-500/50 bg-green-500/10 px-5 py-2 shadow-[0_0_18px_rgba(0,255,0,0.25)] pulse-glow">
        <Trophy className="w-4 h-4 text-green-400" />
        <span className="text-green-400 text-sm font-bold tracking-wide">
          {milestone.toLocaleString()}+ SOLD
        </span>
        <span className="text-green-500/70 text-sm">and counting</span>
      </div>
    </div>
  );
};
